module.exports = __webpack_public_path__ + "static/img/phone.941444f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/admin-order/phone.png
// module id = 9fvI
// module chunks = 4